import { render } from "./ExportUserIds.vue?vue&type=template&id=2d118499&scoped=true"
import script from "./ExportUserIds.vue?vue&type=script&lang=js"
export * from "./ExportUserIds.vue?vue&type=script&lang=js"

import "./ExportUserIds.vue?vue&type=style&index=0&id=2d118499&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d118499"]])

export default __exports__